import { render, staticRenderFns } from "./GatIcon.vue?vue&type=template&id=19052955&scoped=true&"
import script from "./GatIcon.vue?vue&type=script&lang=js&"
export * from "./GatIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19052955",
  null
  
)

export default component.exports